export default __webpack_public_path__ + "img/footer/facebook-black.595dd994456632d537d65df258f7f82e.svg";